/* NextSells · formato monetario compartido y comprobable fuera del navegador. */
(function (root, factory) {
  "use strict";

  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.NextSellsMoney = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  function normalizeLocale(locale, country) {
    var language = String(locale || "").trim().replace(/_/g, "-");
    var region = String(country || "").trim().toUpperCase();
    if (/^[a-z]{2}$/i.test(language) && /^[A-Z]{2}$/.test(region)) {
      return language.toLowerCase() + "-" + region;
    }
    return language || "es-CO";
  }

  function formatMajorUnits(value, symbol, currency, locale) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) amount = 0;

    var currencyCode = String(currency || "COP").trim().toUpperCase();
    try {
      return new Intl.NumberFormat(normalizeLocale(locale), {
        style: "currency",
        currency: currencyCode
      }).format(amount);
    } catch (error) {
      var fraction = amount % 1 === 0 ? 0 : 2;
      return (symbol || "$\u00a0") + amount.toLocaleString(normalizeLocale(locale), {
        minimumFractionDigits: fraction,
        maximumFractionDigits: 20
      });
    }
  }

  return {
    formatMajorUnits: formatMajorUnits,
    normalizeLocale: normalizeLocale
  };
});
